import React from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import clientData from '../../data/clientData.json'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const Details = () => {

  let { id } = useParams()
  const [lightboxOpen, setLightboxOpen] = React.useState(false)
  const [lightboxIndex, setLightboxIndex] = React.useState(0)
  if (!clientData[id])
    return (
      <Link to="/">Retreat from the void.</Link>
    )

  return (
    <>
      <p>{clientData[id].displayName}.</p>
      <Lightbox
        styles={{ container: { backgroundColor: "#000000" }}}
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={
          clientData[id].images.map((filename) => {
            return { src: require(`../../data/images/${id}/${filename}`) }
          })
        }
        index={lightboxIndex}
      />
      <div className="gallery">
        {
          [
            ...clientData[id].videos?.map((filename) => {
              return <video autoplay="true" muted="true" loop="true" src={require(`../../data/images/${id}/${filename}`)}></video>
            }) || [],
            ...clientData[id].images?.map((filename, index) => {
              return <img src={require(`../../data/images/${id}/${filename}`)} onClick={() => {setLightboxIndex(index);setLightboxOpen(true)}}></img>
            }) || []            
          ]
        }
      </div>
      
    </>

  )
}

export default Details